interface ScenarioItem {
  icon: string;
  title: string;
  description: string;
}

interface ScenariosSectionProps {
  sectionTitle: string;
  sectionSubtitle: string;
  items: ScenarioItem[];
}

export default function ScenariosSection({ sectionTitle, sectionSubtitle, items }: ScenariosSectionProps) {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
            {sectionTitle}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {sectionSubtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg p-6 md:p-7 flex flex-col items-center text-center hover:border-background-300/40 border border-transparent transition-all duration-300 cursor-default"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-50 text-accent-600 mb-4">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}